module.exports = __webpack_public_path__ + "static/a5-938beefb498eb62398077f2e32c20d4e.svg";